export default (response, arquivo = null) => {
  const result = document.createElement('a');
  
  if (arquivo === null) {
    let contentDisposition = response.headers.map["content-disposition"];

    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    let matches = filenameRegex.exec(contentDisposition);
    
    if (matches != null && matches[1]) {
      arquivo = matches[1].replace(/['"]/g, '');
    }
  } 

  return response.blob()
    .then(function(data) {
      result.href = window.URL.createObjectURL(data);
      result.target = '_self';
      result.download = arquivo;

      return {
        download() {
          result.click();
        }
      };
  })
}



// WEBPACK FOOTER //
// ./FrontEnd/js/salvar-arquivo.js